import { render, staticRenderFns } from "./BPModal.vue?vue&type=template&id=78696d82&"
import script from "./BPModal.vue?vue&type=script&lang=js&"
export * from "./BPModal.vue?vue&type=script&lang=js&"
import style0 from "./BPModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BPModal.vue"
export default component.exports